import { render, staticRenderFns } from "./CategorySales.vue?vue&type=template&id=e0baea82&"
import script from "./CategorySales.vue?vue&type=script&lang=ts&"
export * from "./CategorySales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports